// extracted by mini-css-extract-plugin
module.exports = {"main":"app-nav-link_main__13W3K"};